import { render, staticRenderFns } from "./DelayedInvoice.vue?vue&type=template&id=081ab384"
import script from "./DelayedInvoice.vue?vue&type=script&lang=js"
export * from "./DelayedInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports